<div
  class="tree-list-action-bar"
  id="tree-list-action-bar"
  [ngStyle]="{ width: _actionsBarOptions.width || '50%' }"
  [class.active-animation]="isShowAnimation()"
>
  <div class="tree-list-action-bar-summary">
    <ng-container *ngTemplateOutlet="selectionSummaryTemp; context: { selection: _selection }"></ng-container>
  </div>
  <div class="tree-list-actions">
    <ng-template #renderSelectionAction let-action>
      @if (!action?.multiple) {
      <div class="{{ action?.icon ? action?.wrapperClass : '' }}">
        <button
          mat-button
          class="tick-btn"
          [ngClass]="action?.class"
          [disabled]="action?.disabled"
          (click)="action?.allItemsCommand(_selection)"
          [attr.data-cy]="action?.dataCy"
          [appHasRight]="action?.rights"
          title="{{ action?.tooltipValue | translate }}"
        >
          @if(action?.icon) {
          <mat-icon class="ps-1">{{ action.icon }}</mat-icon>
          }
          {{ action?.selectionLabel?.(_selection) || action?.label }}
        </button>
      </div>
      } @else {
      <app-btn-group
        [attr.data-cy]="action?.dataCy ? action?.dataCy : 'actionGroup'"
        [appHasRight]="action?.rights"
        className="{{ action?.class }}"
        [items]="action.groupItems(_selection)"
      >
      </app-btn-group>
      }
    </ng-template>

    @for (action of _actions | slice : 0 : _actionsBarOptions.slice; track action?.label) {
    @if(action?.allItemsCommand) {
    <ng-container>
      <ng-container *ngTemplateOutlet="renderSelectionAction; context: { $implicit: action }"></ng-container>
    </ng-container>
    } } @if(_buttonGroupActions?.length) {
    <app-btn-group
      [items]="_buttonGroupActions"
      [withTogglerIcon]="true"
      className="tick-btn-white"
    ></app-btn-group>
    } @if(_fixedActions?.length) {
    <ng-container>
      @for (action of _fixedActions; track action?.label) { @if(action?.allItemsCommand) {
      <ng-container *ngTemplateOutlet="renderSelectionAction; context: { $implicit: action }"></ng-container>
      } }
    </ng-container>
    }
  </div>
</div>
